export default __webpack_public_path__ + "static/media/logout.4a8cec03.svg";